export const marketplaceBrowseTour = {
  tourKey: 'marketplace_browse',
  conditions: {
    orgTypes: ['npo', 'business'],
    userTypes: ['admin', 'staff'],
    plans: null,
  },
  steps: [
    {
      // No target - centered welcome popover
      title: 'tours.marketplace-browse.welcome.title',
      content: 'tours.marketplace-browse.welcome.content',
      placement: 'center',
    },
    {
      target: '[data-tour="marketplace-filter-rail"]',
      title: 'tours.marketplace-browse.filters.title',
      content: 'tours.marketplace-browse.filters.content',
      placement: 'right',
    },
    {
      target: '[data-tour="marketplace-search"]',
      title: 'tours.marketplace-browse.search.title',
      content: 'tours.marketplace-browse.search.content',
      placement: 'bottom',
    },
    {
      target: '[data-tour="marketplace-listings-grid"]',
      title: 'tours.marketplace-browse.listings.title',
      content: 'tours.marketplace-browse.listings.content',
      placement: 'top',
    },
    {
      // No target - centered closing popover
      title: 'tours.marketplace-browse.how-buying-works.title',
      content: 'tours.marketplace-browse.how-buying-works.content',
      placement: 'center',
    },
  ],
};
